import { createContext, ReactNode, useState, useMemo, useContext } from 'react';

type Block = {
  itemId: string;
};

type FillInBlanksSettings = {
  activeSentence: Block;
  activeAnswer: Block;
  setActiveSentence: (sentence: Block) => void;
  setActiveAnswer: (answer: Block) => void;
};

export const FillInBlanksSettingsContext = createContext<FillInBlanksSettings>({
  activeSentence: {
    itemId: '',
  },
  activeAnswer: {
    itemId: '',
  },
  setActiveSentence: () => {},
  setActiveAnswer: () => {},
});

export const FillInBlanksSettingsContextProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [activeSentence, setActiveSentence] = useState<Block>({
    itemId: '',
  });

  const [activeAnswer, setActiveAnswer] = useState<Block>({
    itemId: '',
  });

  const value = useMemo(
    () => ({
      activeSentence,
      setActiveSentence,
      activeAnswer,
      setActiveAnswer,
    }),
    [activeSentence, setActiveSentence, activeAnswer, setActiveAnswer]
  );

  return (
    <FillInBlanksSettingsContext.Provider value={value}>
      {children}
    </FillInBlanksSettingsContext.Provider>
  );
};

export const useFillInBlanksSettingsContext = () =>
  useContext(FillInBlanksSettingsContext);
